// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-70percent[data-v-4b8abf59] {\n  width: 70%;\n}\na[data-v-4b8abf59] {\n  text-decoration: underline;\n}\n.title-amount[data-v-4b8abf59] {\n  font-weight: normal;\n}\n", ""]);
// Exports
module.exports = exports;
